import { render, staticRenderFns } from "./Pollstar.vue?vue&type=template&id=d37b2a5a&scoped=true&"
import script from "./Pollstar.vue?vue&type=script&lang=js&"
export * from "./Pollstar.vue?vue&type=script&lang=js&"
import style0 from "./Pollstar.vue?vue&type=style&index=0&id=d37b2a5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37b2a5a",
  null
  
)

export default component.exports